export type ExampleSegment =
  | { kind: 'text'; value: string }
  | { kind: 'chip'; value: string };

const TECHNICAL_TOKEN_PATTERN =
  /(Authorization:\s*Bearer\s*(?:\u2026|\.{3}|…)|https?:\/\/[^\s)\]}>,"']+|\b(?:[a-z0-9-]+\.){2,}[a-z]{2,}\b|\bCookie\b)/g;

export function splitExampleTechnicalTokens(example: string): ExampleSegment[] {
  const segments: ExampleSegment[] = [];
  let lastIndex = 0;

  for (const match of example.matchAll(TECHNICAL_TOKEN_PATTERN)) {
    const value = match[0];
    const index = match.index ?? 0;

    if (index > lastIndex) {
      segments.push({ kind: 'text', value: example.slice(lastIndex, index) });
    }

    segments.push({ kind: 'chip', value });
    lastIndex = index + value.length;
  }

  if (lastIndex < example.length) {
    segments.push({ kind: 'text', value: example.slice(lastIndex) });
  }

  return segments.length > 0 ? segments : [{ kind: 'text', value: example }];
}
